<template>
  <div id="loading-container">
    <md-progress-spinner class="md-accent" md-mode="indeterminate"></md-progress-spinner>
  </div>
</template>

<script>
  export default {
    name: 'loading-overlay',
  };
</script>

<style scoped>
  #loading-container {
    z-index: 10;
    position: relative;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoadOverlay.vue